export enum LoginActionTypes {
    REQUEST = '@@auth/login/request',
    SUCCESS = '@@auth/login/success',
    ERROR = '@@auth/login/error'
}

export enum LogoutActionTypes {
    REQUEST = '@@auth/logout/request',
    SUCCESS = '@@auth/logout/success',
    ERROR = '@@auth/logout/error'
}

export enum GetIsAuthenticatedActionTypes {
    REQUEST = '@@auth/get-is-authenticated/request',
    SUCCESS = '@@auth/get-is-authenticated/success',
    ERROR = '@@auth/get-is-authenticated/error'
}
